<template>
  <div class="container">
    <div>

      <h2>Upload de CSV</h2>
      <hr/>

      <div class="drag-area flex w-full h-screen items-center justify-center text-center" @dragover.prevent="dragOver" @dragleave="dragleave" @drop.prevent @drop="dragFile">
        <input style="display:none;" type="file" id='file-upload' accept=".csv" @change="handleFileUpload( $event )"/>

        <label for="file-upload" class="cursor-pointer text">
          Arraste o arquivo para área azul ou <span class="underline">clique aqui</span> para subir um novo arquivo. 
          Esse arquivo deve ser do tipo csv separado por vírgula.
        </label>

        <label for="file-upload" class="cursor-pointer text">
          Campos do arquivo csv: Nome completo do Aluno,Curso,Turma,Telefone,Matrícula (RA),Data de Atualização,Status da Matrícula,Nome do Responsável,E-mail do Responsável,Código da Família
          <br>
          <small>
            O arquivo é identificado pelo cabeçalho, então a ordem das colunas não importa e
            colunas ausentes preservam o que já está cadastrado. Datas no formato dd/mm/aaaa.
          </small>
        </label>

        <div v-if="file">
          {{ file.name }}
        </div>

        <br>

        <div v-if="saving" class="pb-1">
            <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Atualizando base de contatos. Por favor, aguarde...</strong></p>
        </div>
        <button v-else v-on:click="submitFile()">Enviar</button>

        <div class="template-section">
          <span class="template-label"><i class="fas fa-file-csv"></i> Baixar Modelo</span>
          <a href="#" class="template-link" @click.prevent="downloadTemplate()">
            <i class="fas fa-download"></i> modelo_contatos.csv
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            file: '',
            saving: false
        }
    },
    methods: {
        handleFileUpload( event ){
            this.file = event.target.files[0];
        },
        
        dragFile(e){
          document.getElementById('file-upload').files = e.dataTransfer.files;

          this.file = document.getElementById('file-upload').files[0];
          console.log('file', this.file);
          // Clean up
          e.currentTarget.classList.remove('gray');
          e.currentTarget.classList.add('salmon');

        },
        dragOver(event){
          event.currentTarget.classList.add('gray');
          event.currentTarget.classList.remove('salmon');
        },
        dragleave(event){
          // Clean up
          event.currentTarget.classList.remove('gray');
          event.currentTarget.classList.add('salmon');
        },
        downloadTemplate(){
          const header = "Nome completo do Aluno,Curso,Turma,Telefone,Matrícula (RA),Data de Atualização,Status da Matrícula,Nome do Responsável,E-mail do Responsável,Código da Família";
          const exemplo = "João da Silva,Ensino Médio,3º A,(11) 99999-9999,RA-2026001,07/08/2026,Ativa,Maria da Silva,maria.silva@email.com,FAM-001234";
          const csvContent = header + "\n" + exemplo;
          const blob = new Blob(["﻿" + csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', 'modelo_contatos.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        },
        submitFile(){
            this.saving = true
            let formData = new FormData();
            let file = document.getElementById('file-upload').files[0];

            if(!this.file){
              Swal.fire({
                type: "warning",
                title: "Arquivo não anexado!",
                text: "Por favor, escolha um arquivo CSV para upload!"
              })
              this.saving = false;
              return;
            }

            formData.append('file', file);

            axios.post( '/customer_base/store',
               formData
            ).then((response) => {
              Swal.fire(
                'Upload realizado',
                response.data.msg,
                response.data.lines && response.data.lines.length ? 'warning' : 'success'
              )
              this.saving = false;
              document.getElementById('file-upload').value = "";
              this.file = '';
              this.$emit('updateList');
            })
            .catch((error) => {
                const msg = error.response && error.response.data && error.response.data.msg
                  ? error.response.data.msg
                  : 'Não foi possível processar o arquivo.';
                Swal.fire('Erro no upload', msg, 'error');
                this.saving = false;
            });
      },
    }
}
</script>

<style scoped>
.text{
  padding:1em;
}

.drag-area{

  display: block;
  width: 100%;
  background-color:rgba(28, 133, 154, .05);

}

.gray{
   background-color:rgba(28, 133, 154, 1);
}

.salmon{
  background-color:rgba(28, 133, 154, .05);
}
button{
  border: none;
  background-color: #1c869a;
  width: 49%;
  margin: 1em auto;
  padding: 1em;
  color: white;
  font-family: 'Noto Sans KR', sans-serif;
  text-transform: uppercase;
}

.underline{
  text-decoration: underline;
}

.template-section{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75em;
  padding: 0.75em 1em;
  margin-top: 0.5em;
  background-color: rgba(28, 133, 154, 0.08);
  border-top: 1px solid rgba(28, 133, 154, 0.2);
  width: 100%;
}

.template-label{
  font-size: 0.85em;
  color: #555;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.template-link{
  font-size: 0.85em;
  color: #1c869a;
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.2s;
}

.template-link:hover{
  opacity: 0.75;
  text-decoration: underline;
}
</style>